import { useIsActiveStationAudio } from '@app/core/stations/hooks/useIsActiveStationAudio';
import { useIsActiveStationVideo } from '@app/core/stations/hooks/useIsActiveStationVideo';
import { useIsActiveStationYoutubeNative } from '@app/core/stations/hooks/useIsActiveStationYoutubeNative';
import { Box } from '@mui/material';
import { useStreamSegments } from '../../hooks/segments/useStreamSegmentsQuery';
import { ControlDivider } from './components/control-divider/ControlDivider';
import { LoadLatestControl } from './components/load-latest/LoadLatestControl';
import { PartialSegmentCoverageWarning } from './components/partial-segment-coverage/PartialSegmentCoverageWarning';
import { DateControl } from './components/set-date-time/DateControl';
import { TimeControl } from './components/set-date-time/TimeControl';
import { StationPlayLive } from './components/StationPlayLive';
import { StreamFeatureControls } from './components/stream-feature-controls/StreamFeatureControls';
import { TimeMoveBackwardsControl } from './components/time-move/TimeMoveBackwardsControl';
import { TimeMoveForwardsControl } from './components/time-move/TimeMoveForwardsControl';
import { YoutubeBroadcastsListControl } from './components/youtube-broadcasts-list/YoutubeBroadcastsListControl';
import { YoutubeLiveCounter } from './components/youtube-live/YoutubeLiveCounter';

export function NavigationControls() {
  const { isLoading } = useStreamSegments();
  const isVideo = useIsActiveStationVideo();
  const isAudio = useIsActiveStationAudio();
  const isYoutubeNative = useIsActiveStationYoutubeNative();

  // Disable time/date controls only while segments are loading. When range is future or too recent,
  // keep controls enabled so the user can change date/time to select a valid range.
  const controlsDisabled = isLoading;

  return (
    <Box
      style={{
        gap: '16px',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <DateControl isDisabled={controlsDisabled} />
        <ControlDivider />
        <TimeControl isDisabled={controlsDisabled} />
        <PartialSegmentCoverageWarning />
        <ControlDivider />
        <Box display="flex" alignItems="center" gap={1.5}>
          <TimeMoveBackwardsControl isDisabled={controlsDisabled} />
          <TimeMoveForwardsControl isDisabled={controlsDisabled} />
        </Box>
        <ControlDivider />
        <LoadLatestControl isDisabled={controlsDisabled} />
        {isYoutubeNative && (
          <>
            <ControlDivider />
            <YoutubeBroadcastsListControl />
          </>
        )}
      </Box>
      <Box display="flex" alignItems="center" gap={2}>
        {isVideo && <YoutubeLiveCounter />}
        {isAudio && <StationPlayLive />}
        <StreamFeatureControls />
      </Box>
    </Box>
  );
}
